import {Editor} from '@tiptap/react';
import React from 'react';
import {useSelector} from 'react-redux';
import {ChainedCommands} from '@tiptap/core';
import TextEditorButton from '../../../../../incase-domain/components/textEditor/TextEditorButton';
import TextEditorButtonWrapper from '../../../../../incase-domain/components/textEditor/TextEditorButtonWrapper';
import {editorModeSelector} from '../../../../../store/selectors/tiptapEditor.selectors';
import {EditorModeEnum} from '../../../../../store/actions/types/tiptapEditor.types';

interface TextFormattingToolbarProps {
    editor: Editor;
}

function TextFormattingToolbar({editor}: TextFormattingToolbarProps): JSX.Element {
    const editorMode = useSelector(editorModeSelector);

    const applyCommand = (fn: (chain: ChainedCommands) => ChainedCommands): void => {
        if (editorMode === EditorModeEnum.SELECT) {
            fn(editor.chain().selectAll()).run();
        } else {
            fn(editor.chain().focus()).run();
        }
    };

    return (
        <div style={{display: 'flex', gap: '1rem'}}>
            <div style={{display: 'flex', flexDirection: 'row', gap: '0.2rem'}}>
                <TextEditorButton
                    icon="ph:text-h-one"
                    onClick={() => applyCommand((c) => c.toggleHeading({level: 1}))}
                    isActive={editor.isActive('heading', {level: 1})}
                />
                <TextEditorButton
                    icon="ph:text-h-two"
                    onClick={() => applyCommand((c) => c.toggleHeading({level: 2}))}
                    isActive={editor.isActive('heading', {level: 2})}
                />
                <TextEditorButton
                    icon="ph:text-h-three"
                    onClick={() => applyCommand((c) => c.toggleHeading({level: 3}))}
                    isActive={editor.isActive('heading', {level: 3})}
                />
                <TextEditorButton
                    icon="ph:text-h-four"
                    onClick={() => applyCommand((c) => c.toggleHeading({level: 4}))}
                    isActive={editor.isActive('heading', {level: 4})}
                />
            </div>
            <TextEditorButtonWrapper>
                <TextEditorButton
                    icon="ph:list-bullets"
                    onClick={() => applyCommand((c) => c.toggleBulletList())}
                    isActive={editor.isActive('bulletList')}
                />
                <TextEditorButton
                    icon="ph:list-numbers"
                    onClick={() => applyCommand((c) => c.toggleOrderedList())}
                    isActive={editor.isActive('orderedList')}
                />
            </TextEditorButtonWrapper>
        </div>
    );
}

export default TextFormattingToolbar;
